module.exports = __webpack_public_path__ + "static/seo-geriana-c308f2a7db6b3d2359e15009bff2bdf9.png";